import axios from 'axios'
import store from "../reducers/redux-index"
import searchVars from "../searchVar.json";

const TILE_PER_PAGE = searchVars.TILE_PER_PAGE;

export const getResultFromGeoPoint = (geoPoint) => {
    console.log("Test: ", TILE_PER_PAGE)
    const params = {
        ...geoPoint,
        dist: 0,
        page: 1,
        elementPerPage: TILE_PER_PAGE
    }
    axios.get(process.env.REACT_APP_API_URL + "/api/v1/rides", {//159.89.236.159
        params
    }).then(
        (res) => {
            store.dispatch({
                type: "FRESH_SEARCH",
                payload: { data: res.data, page: 1, searchCriteria: params }
            })
        }
    ).catch(err => {
        console.log(err)
    })
}

export const getAdvancedResult = (values) => {
    axios.get(process.env.REACT_APP_API_URL + "/api/v1/rides", {//159.89.236.159
        params: values
    }).then(
        (res) => {
            store.dispatch({
                type: "FRESH_SEARCH",
                payload: {
                    data: res.data,
                    page: 1,
                    searchCriteria: values
                }
            })
        }
    ).catch(err => {
        console.log(err)
    })
}

export const getNewPageSearch = (params, pageNumber, dataLength, isNext) => {
    if (pageNumber > 0) {
        if (isNext && dataLength / TILE_PER_PAGE < pageNumber && dataLength % TILE_PER_PAGE === 0) {
            params.page = pageNumber;
            axios.get(process.env.REACT_APP_API_URL + "/api/v1/rides", {//159.89.236.159
                params
            }).then(
                (res) => {
                    if (res.data && res.data.length > 0) {
                        store.dispatch({
                            type: "PAGE_SEARCH",
                            payload: { data: res.data, page: pageNumber, searchCriteria: params }
                        })
                    }
                    else {
                        store.dispatch({
                            type: "SET_LAST_PAGE"
                        })
                    }
                }
            ).catch(err => {
                console.log(err)
            })
        }
        else {
            store.dispatch({
                type: "CHANGE_PAGE",
                payload: { page: pageNumber }
            })
        }
    }
}